export enum AmortissementsMode {
  IN_FINE = "IN FINE",
  AMORTISSABLE = "AMORTISSABLE",
}

